import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 30000,
});

// Cliente con timeout extendido para generacion IA (texto + imagen, puede tardar 1-3 min)
export const apiLong = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 300000,
});

const attachToken = (config) => {
  const token = localStorage.getItem("cfe_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

api.interceptors.request.use(attachToken);
apiLong.interceptors.request.use(attachToken);

export const formatFecha = (fechaStr) => {
  if (!fechaStr) return "";
  try {
    const d = new Date(`${fechaStr}T12:00:00`);
    return d.toLocaleDateString("es-VE", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return fechaStr;
  }
};

export const formatFechaHora = (isoStr) => {
  if (!isoStr) return "";
  try {
    const d = new Date(isoStr);
    return d.toLocaleDateString("es-VE", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return isoStr;
  }
};
